export function roundToIncrement(value: number, increment: number) {
  return Math.round(value / increment) * increment;
}
